import React from "react";
import { Container, CssBaseline } from "@mui/material";

const BaseContainer = ({ children, maxWidth = "xs", sx = {} }) => (
  <Container
    component="main"
    maxWidth={maxWidth}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "70vh",
      ...sx,
    }}
  >
    <CssBaseline />
    {children}
  </Container>
);

export default BaseContainer;
